import { ApiService } from '@b2b/common/services/api/types';
import { TODO, UIBModal } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope } from 'angular';

export const FormsModalsSchedulesControllerModule = angular
  .module('acme.view.application.forms.modals.schedules.controllers', [
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.common.service.userPreferences',
    'acme.common.service.helpers',
    'acme.common.service.templates',
    'acme.common.service.templates.helpers',
  ])
  .controller('FormsModalsSchedulesController', [
    '$scope',
    '$state',
    '$uibModalInstance',
    '$filter',
    'ApiService',
    'GridStateFactory',
    'GridDefinitionFactory',
    'UserPreferencesService',
    'HelpersService',
    'TemplatesHelpersService',
    'TemplatesService',
    'isPublish',
    function (
      $scope: IScope & { formsModalsSchedules: TODO },
      $state: StateService,
      $uibModalInstance: UIBModal<TODO>,
      $filter: IFilterService,
      ApiService: ApiService,
      GridStateFactory: TODO,
      GridDefinitionFactory: TODO,
      UserPreferencesService: TODO,
      HelpersService: TODO,
      TemplatesHelpersService: TODO,
      TemplatesService: TODO,
      isPublish: TODO
    ) {
      $scope.formsModalsSchedules = {
        model: [],
        isLoaded: false,

        gridState: new GridStateFactory(),

        viewId: '',
        gridName: $state.current.name + '.modal.grid0',
        dateFormat: UserPreferencesService.getDateFormat('shortDate', 'dateFormat'),

        grid: {
          enableGridMenu: false,
          pageSize: 10,
          paginate: true,
          useExternalPagination: true,
          useExternalSorting: false,
          enableRowSelection: false,
          enableSorting: false,
          showFooter: true,
          columns: [
            {
              field: 'id',
              displayName: 'Id',
              visible: false,
            },
            {
              field: 'templateName',
              displayName: 'Event Template Name',
              sort: {
                direction: 'asc',
              },
            },
            {
              field: 'scheduleName',
              displayName: 'Schedule Name',
            },
            {
              field: 'effectiveDates',
              displayName: 'Effective',
            },
            {
              field: 'repeatCycle',
              displayName: 'Occurs',
            },
            {
              field: 'salesChannels',
              displayName: 'Channels',
            },
          ],
        },
        init: function () {
          this.isLoading = true;

          this.isPublish = isPublish;
          this.viewId = $state.current.name;
          this.gridState.updateGridState(1, this.grid.pageSize, 'templateName', 'asc');
          this.getSchedules();
        },

        getSchedules: function () {
          ApiService.program.resources.schedule
            .summary(angular.extend({ formId: $state.params.formId }, this.gridState.getGridState()))
            .then(this.success.init)
            .catch(this.error.init);
        },

        onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
          const self = $scope.formsModalsSchedules;
          const data = {
            currentPage: newPageNumber || 1,
            pageSize: newPageSize || this.gridDefinition.options.paginationPageSize,
          };

          self.gridState.updateGridState(data.currentPage, data.pageSize);
          if (sortField) {
            self.gridState.updateGridState(null, null, sortField, null);
          }
          if (sortDirection) {
            self.gridState.updateGridState(null, null, null, sortDirection);
          }

          self.getSchedules();
        },

        onDataGridSortChange: function (grid, columns) {
          const self = $scope.formsModalsSchedules;
          const data = columns[0];

          if (data) {
            self.gridState.updateGridState(null, null, data.field, data.sort.direction);

            self.getSchedules();
          }
        },

        processEventSchedules: function () {
          const self = $scope.formsModalsSchedules;
          const res = self.model.filter(function (item) {
            item.effectiveDates = TemplatesHelpersService.getEffectiveDates(
              item.effectiveStartTime,
              item.effectiveEndTime
            );
            item.repeatCycle = TemplatesHelpersService.getRepeatType(
              TemplatesHelpersService.getRepeatTypes(),
              item.frequency
            ).label;
            item.salesChannels = TemplatesService.getSalesChannels(item.salesChannels);
            return item;
          });

          return res;
        },

        confirm: function () {
          $uibModalInstance.close(true);
        },

        close: function () {
          $uibModalInstance.dismiss('cancel');
        },

        success: {
          init: function (response) {
            const self = $scope.formsModalsSchedules;
            self.model = response.data.payload.list;
            self.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);
            self.eventSchedules = self.processEventSchedules();
            self.isLoaded = true;
          },
        },

        error: {
          init: function (response) {},
        },
      };

      $scope.formsModalsSchedules.init();
    },
  ]).name;
